import { useParams, useSearchParams } from 'react-router'
import { LoadingDots } from 'src/components/LoadingDots/LoadingDots'
import { useSendVideoCallStartedNotification } from 'src/features/explanation/api/sendVideoCallStartedNotification'
import { VideoCallRoom } from 'src/features/videoCall/components'
import { ExplanationPatientForHospitalTrialPatientVideoCallScreenDocument } from 'src/lib/gql-client'
import { useGqlQuerySWRNoSuspense } from 'src/lib/gql-client/request'

import { useTrialPatientVideoCallToken } from '../../api/setupTrialPatientVideoCallToken'

type Param = {
  trialPatientUid: string
}

export const HospitalTrialPatientVideoCallScreen: React.FC = () => {
  const { trialPatientUid } = useParams<Param>()
  const [searchParams] = useSearchParams()
  const inviteeType = searchParams.get('inviteeType')

  const { data, setupJwtToken } = useTrialPatientVideoCallToken()

  const { request: sendVideoCallStartedNotification } =
    useSendVideoCallStartedNotification()

  if (!trialPatientUid || !inviteeType) {
    throw new Error('trialPatientUid or inviteeType is not provided')
  }

  useGqlQuerySWRNoSuspense(
    ExplanationPatientForHospitalTrialPatientVideoCallScreenDocument,
    !!data?.token
      ? null
      : {
          input: {
            trialPatientUid,
          },
        },
    {
      onSuccess: async () => {
        if (!trialPatientUid) return
        await setupJwtToken(trialPatientUid)
      },
    },
  )

  if (!data) {
    return <LoadingDots />
  }

  return (
    <VideoCallRoom
      token={data.token}
      videoCallUserUid={data.videoCallUserUid}
      screenShareUserUid={data.screenShareUserUid}
      screenShareToken={data.screenShareToken}
      roomUid={data.videoCallRoomUid}
      agoraCloudProxyMode={data.agoraCloudProxyMode}
      sendNotification={async () => {
        await sendVideoCallStartedNotification({
          trialPatientUid,
          scene: 'VideoCall',
          sendTo: inviteeType === 'Patient' ? 'Patient' : 'PartnerMembers',
        })
      }}
      canShareScreen={true}
      scene="EConsentVideoCall" // eSourceにいtrialPatientVideoCallを使う可能性はあるが、現状は"EConsentExplanation"のみ
    />
  )
}
